export enum CountryId {
    Usa = 1,
    Canada = 2
}